import { Divider, Grid } from '@mui/material';
import { BenefitDTO, FlexBenefitDetailsDTO } from 'probonio-shared-ui/api';
import { BENEFIT_PICTURES } from 'probonio-shared-ui/component/button';
import React from 'react';
import {
  BenefitListItemExtensionInterface,
  getBenefitListItemExtension,
} from '../../../extension/interface/benefit-list-item.extension.interface';
import { getBenefitIcon } from '../../benefit/BenefitIcon';
import { BenefitCardNavButton, BenefitItemCard } from '../../benefit/BenefitItem';

export class FlexBenefitListItemExtension extends BenefitListItemExtensionInterface {
  isHidden(activeBenefit: BenefitDTO, activeBenefits: BenefitDTO[], context?: Record<string, unknown>): boolean {
    return false;
  }

  getListItemProps(): null {
    // Flex always uses custom rendering
    return null;
  }

  renderCustomContent(activeBenefit: BenefitDTO, activeBenefits: BenefitDTO[]): React.ReactNode {
    const detailsFlex = activeBenefit.details as FlexBenefitDetailsDTO;

    return (
      <BenefitItemCard
        icon={getBenefitIcon(activeBenefit.benefit)}
        titleKey={`benefit.${activeBenefit.benefit}.name`}
        navigateTo="/flex"
        picture={BENEFIT_PICTURES[activeBenefit.benefit]}
        descriptionKey={`benefitModule:benefit.${activeBenefit.benefit}.description`}
        descriptionValues={{ usedBudget: detailsFlex.usedBudget, monthlyBudget: detailsFlex.monthlyBudget }}
        benefitProgress={
          detailsFlex.monthlyBudget <= 0 ? 0 : Math.min(Math.max((detailsFlex.usedBudget / detailsFlex.monthlyBudget) * 100, 0), 100)
        }
      >
        {detailsFlex.flexBenefits
          .map((benefit, index, array) => {
            const benefitDto = activeBenefits.find(dto => dto.benefit === benefit);
            if (!benefitDto) return null;

            const extension = getBenefitListItemExtension(benefitDto.benefit);
            const listItemProps = extension?.getListItemProps(benefitDto, activeBenefits);

            if (!listItemProps) {
              return null;
            }

            return (
              <Grid key={benefitDto.benefit}>
                <BenefitCardNavButton {...listItemProps} />
                {index < array.length - 1 && <Divider sx={{ mx: 0.75, borderWidth: 0, borderBottomWidth: 'thin' }} />}
              </Grid>
            );
          })
          .filter(Boolean)}
      </BenefitItemCard>
    );
  }
}
